import { render, staticRenderFns } from "./ChangeLanguageDropdown.vue?vue&type=template&id=4b52867e"
import script from "./ChangeLanguageDropdown.vue?vue&type=script&lang=js"
export * from "./ChangeLanguageDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports